import React, { useState } from 'react';
import {
  Container,
  Box,
  makeStyles,
  AppBar,
  Toolbar,
  Button,
  Grid,
  Typography,
  Divider,
} from '@material-ui/core';
import { primary } from '../../theme';

import Intro from './Intro';
import Survey from './Survey';

const useStyles = makeStyles(() => ({
  appBar: {
    fontFamily: 'Open Sans, sans-serif',
    top: 'auto',
    bottom: 0,
  },
  grow: {
    flexGrow: 1,
  },
  paper: {
    padding: 0,
    textAlign: 'center',
  },
  nextButton: {
    fontFamily: 'Open Sans, sans-serif',
    minWidth: '100%',
  },
  divider: {
    height: 2,
    color: '#707070',
    marginBottom: 25,
  },
  pageTitle: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: 20,
    fontWeight: 700,
    marginTop: 50,
    marginBottom: 20,
    color: primary.purple,
  },
}));

const HomePage = () => {
  const classes = useStyles();

  const [started, setStarted] = useState(false);

  if (started) {
    window.scrollTo(0, 0);
    return <Survey />;
  }

  return (
    <Container maxWidth="xl">
      <Box py={1} px={2}>
        <Typography className={classes.pageTitle}>LIVE ABOVE THE LINE</Typography>
        <Divider className={classes.divider} />
        <Intro />
      </Box>
      <AppBar position="fixed" color="primary" className={classes.appBar}>
        <Toolbar>
          <div className={classes.grow}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box className={classes.paper}>
                  <Button
                    onClick={() => setStarted(true)}
                    variant="contained"
                    color="secondary"
                    className={classes.nextButton}
                  >
                    CONTINUE
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </div>
        </Toolbar>
      </AppBar>
    </Container>
  );
};

export default HomePage;
